import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { ellipsis } from '~lib/styles/Theme/common';

export const Wrapper = styled.a`
  display: flex;
  width: 230px;
  height: 60px;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;
  ${ellipsis};

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    width: 100%;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.h4`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.gray900};
  ${getFontStyle('bold120_B3')};
  ${ellipsis};
`;

export const Reward = styled.p`
  color: ${({ theme }) => theme.colors.gray700};
  ${getFontStyle('midium120_C1')};
  ${ellipsis};
`;
